import React from "react";

type InfoCardVariant = 'default' | 'warning';

interface InfoCardProps {
  text: string;
  className?: string;
  variant?: InfoCardVariant;
}

export const InfoCard = ({text, className, variant = 'default'} : InfoCardProps) => {
  if (variant === 'warning') {
    return (
      <div className={`info-card info-card--warning ${className ?? ''}`}>
        <p className='u-fs-14 mb-0'>{text}</p>
      </div>
    )
  }

  return (
    <p className={`info-card ${className ?? ''}`}>
      <i className="icon--16 icon__info--masked bg-danger d-inline-block mr-2" />
      <p className='u-fs-14 text-gray-700'>{text}</p>
    </p>
  )
}
